import { Field, FormikErrors } from 'formik';

import { BankIdConfirmationFormData, BankIdConfirmationFormFields } from '../useBankIdConfirmation';
import { Label, Select, SelectOptionProps, Error } from '@simplea/shared-ui';
import ReactNumberFormat from 'react-number-format';

type Props = {
    errors: FormikErrors<BankIdConfirmationFormData>;
    bankOptions: SelectOptionProps[];
};

export const BankAccount = ({ errors, bankOptions }: Props) => {
    return (
        <>
            <div className="confirmationItemCentered mobileMargin">
                <h3>Bankovní účet</h3>
            </div>
            <div className="bankAccount">
                <Label htmlFor={BankIdConfirmationFormFields.BankAccountPrefix} label="Předčíslí">
                    <Field
                        id={BankIdConfirmationFormFields.BankAccountPrefix}
                        name={BankIdConfirmationFormFields.BankAccountPrefix}
                        as={ReactNumberFormat}
                        className="reactNumberFormat"
                        thousandSeparator={false}
                    />
                </Label>
                <Label htmlFor={BankIdConfirmationFormFields.BankAccountNo} label="Číslo účtu">
                    <Field
                        id={BankIdConfirmationFormFields.BankAccountNo}
                        name={BankIdConfirmationFormFields.BankAccountNo}
                        as={ReactNumberFormat}
                        className="reactNumberFormat"
                        thousandSeparator={false}
                        error={errors.bankAccountNo}
                    />
                    <Error isDisplayed={!!errors.bankAccountNo}>{errors.bankAccountNo}</Error>
                </Label>
                <Label htmlFor={BankIdConfirmationFormFields.BankAccountCode} label="Banka">
                    <Field
                        id={BankIdConfirmationFormFields.BankAccountCode}
                        name={BankIdConfirmationFormFields.BankAccountCode}
                        component={Select}
                        options={bankOptions}
                        error={errors.bankAccountCode}
                    />
                    <Error isDisplayed={!!errors.bankAccountCode}>{errors.bankAccountCode}</Error>
                </Label>
            </div>
        </>
    );
};
